function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, `DF60D2CB-B6D1-4BE4-AA8D-10111A50966A`);

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, `Created with sketchtool.`);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Applications",
  transform: "translate(-894.000000, -305.000000)",
  stroke: "#FFB917"
}, React.createElement("g", {
  id: "approve_icon",
  transform: "translate(893.666667, 304.333333)"
}, React.createElement("circle", {
  id: "Oval-9",
  cx: 7.33333333,
  cy: 7.66666667,
  r: 6.5
}), React.createElement("polyline", {
  id: "Path-2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(7.631013, 7.912902) rotate(-4.000000) translate(-7.631013, -7.912902) ",
  points: "5.16323277 7.72385172 6.70273273 9.60802108 10.098794 6.21778297"
}))));

const SvgComponent = props => React.createElement("svg", _extends({
  width: "14px",
  height: "14px",
  viewBox: "0 0 14 14",
  version: 1.1,
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref, _ref2, _ref3);

export default __webpack_public_path__ + "static/media/icon-approve.e0f11ad7.svg";
export { SvgComponent as ReactComponent };